import { useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import { FaLinkedin, FaInstagram } from 'react-icons/fa';
import { ImProfile } from 'react-icons/im';

const profiles = [
  {
    name: 'Kanishk Sharma',
    image: 'https://i.ibb.co/RBwqqsk/Screenshot-2024-03-24-at-12-07-05-AM-4.jpg',
    linkedin: 'https://www.linkedin.com/in/kanishk-sharma-1884511ab/',
    instagram: 'https://instagram.com/kannywhoo',
    position: 'Chairperson',
  },
  {
    name: 'Ayushi Prasad',
    image: 'https://i.ibb.co/dkRwgP7/Ayushi-Prasad-Design-Head.webp',
    linkedin: 'https://www.linkedin.com/in/ayushi-prasad-59310a1a0/',
    instagram: 'https://www.instagram.com/ayushii1050/',
    github: 'https://www.github.com/johndoe',
    position: 'Vice-Chairperson',
  },
  {
    name: 'Jai Munjal',
    image: 'https://i.ibb.co/hYmtB78/7077b0c2-c368-4345-9331-5dd678336e26.jpg',
    linkedin: 'https://www.linkedin.com/in/johndoe',
    instagram: 'https://www.instagram.com/jai__munjal/',
    position: 'Secretary',
  },
  {
    name: 'Aadithya Koppikar',
    image: 'https://i.ibb.co/mzk0Sr9/1-11zon.jpg',
    linkedin: 'https://www.linkedin.com/in/aadithyakoppikar-k99/',
    instagram: 'https://www.instagram.com/aadithya_k99/',
    position: 'Co-Secretary',
  },
  {
    name: 'Vasu Somani',
    image: 'https://i.ibb.co/NxmN3vC/vasu.jpg',
    linkedin: 'https://www.linkedin.com/in/vasu-somani-80b589242/',
    instagram: 'https://www.instagram.com/vasusomani_22/',
    github: 'https://github.com/vasusomani',
    position: 'Technical and Projects Head',
  },
  {
    name: 'Mihir Joshi',
    image:
      'https://media.licdn.com/dms/image/D5603AQGYIhmZtyIwtQ/profile-displayphoto-shrink_800_800/0/1673988327839?e=1716422400&v=beta&t=9ib_xYuxP1mSnPTjI5x1WTLUMUV6ngT9ryGsMFixsnI',
    linkedin: 'https://www.linkedin.com/in/mihir-shekhar-joshi-1a8589246/',
    instagram: 'https://www.instagram.com/mihxr.7',
    github: 'https://www.github.com/johndoe',
    position: 'Management Head',
  },

  {
    name: 'Parmartha Dhasmana',
    image: 'https://i.ibb.co/gdYg3JR/paramarth.jpg',
    linkedin: 'https://www.linkedin.com/in/parmartha-dhasmana-681aa2244/',
    instagram: 'https://www.instagram.com/parmartha_/',
    github: 'https://www.github.com/johndoe',
    position: 'Events Head',
  },
  {
    name: 'Lohith Pattubala',
    image: 'https://i.ibb.co/HT82nKn/Screenshot-2024-03-24-at-12-06-58-AM-2.jpg',
    linkedin: 'https://www.linkedin.com/in/lohith-pattubala-b1a2b3231',
    instagram: 'https://www.instagram.com/reddy_lohith_pattubala?igsh=azFpZGxhOTlncHYy',
    github: 'https://www.github.com/johndoe',
    position: 'Finance Head',
  },
  {
    name: 'Aanchal Shah',
    image: 'https://i.ibb.co/6YQK4Zc/Screenshot-2024-03-24-at-12-07-14-AM-5.jpg',
    linkedin:
      'https://www.linkedin.com/in/aanchal-shah-66baba2a6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    instagram: 'https://www.instagram.com/_.aanchalshxh._?igsh=MWx0c2htZGdsc2I3eQ==',
    position: 'Design Head',
  },
  {
    name: 'Shailesh Mishra',
    image: 'https://i.ibb.co/dD1S7YJ/compressed-shailesh.jpg',
    linkedin: 'https://www.linkedin.com/in/shailesh-mishra-86b2b6247/',
    instagram: 'https://www.instagram.com/shailesh_8299/',
    position: 'Outreach and Publicity Head',
  },
  {
    name: 'Saahithi Nalla',
    image: 'https://i.ibb.co/mbmXZTD/Screenshot-2024-03-24-at-12-07-02-AM-3.jpg',
    linkedin:
      'https://www.linkedin.com/in/saahithi-nalla-36bb7126a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    instagram: 'https://www.instagram.com/_.saahithi._?igsh=dWZ6cWw0d2htemd3&utm_source=qr',
    github: 'https://www.github.com/johndoe',
    position: 'R&D Head',
  },
];

const facs = [
  {
    name: 'Dr. John Singh K',
    image: 'https://vit.ac.in/sites/default/files/schools/faculty/12442.jpg',
    linkedin: 'https://www.linkedin.com/in/',
    profile: 'https://vitdirectory.vit.ac.in/page/faculty/12442',
    instagram: 'https://www.instagram.com/',
    position: 'Faculty Coordinator',
  },
  {
    name: 'Dr. Shynu P G',
    image: 'https://vit.ac.in/sites/default/files/styles/facultyfilter/public/12340.jpg?itok=U_CEehps',
    linkedin: 'https://www.linkedin.com/in/',
    profile: 'https://vitdirectory.vit.ac.in/page/faculty/12340',
    instagram: 'https://www.instagram.com/',
    position: 'Faculty Coordinator',
  },
];

const Team = () => {
  const [cardState, setCardState] = useState(Array(profiles.length).fill(false));
  const [cardStateProf, setCardStateProf] = useState(Array(profiles.length).fill(false));

  const handleClick = (index) => {
    setCardState((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const handleClickProf = (index) => {
    setCardStateProf((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <div className="team-section-1 relative flex flex-col items-center py-10">
      <h2 className="py-20 text-4xl font-bold text-white md:py-12 md:text-6xl lg:py-20 lg:text-6xl">OUR TEAM</h2>
      <div className="flex flex-col items-center">
        <div className="z-30 grid grid-cols-1 grid-rows-1 gap-28 md:grid-cols-2 lg:grid-cols-2">
          {facs.map((facs, index) => (
            <div>
              <ReactCardFlip key={index} isFlipped={cardStateProf[index]} flipDirection="vertical">
                <div className="card-front relative flex h-72 w-72 items-center justify-center rounded-full bg-gray-100 shadow-md">
                  <button onClick={() => handleClickProf(index)} className="h-full w-full">
                    <img src={facs.image} alt={facs.name} className="h-full w-full rounded-full object-cover" />
                  </button>
                </div>

                <div className="card-back glass-effect-circle relative flex h-72 w-72 flex-col items-center justify-center rounded-full p-6 shadow-md">
                  <button onClick={() => handleClickProf(index)} className="h-full w-full">
                    <div className="mx-20 mt-4 flex justify-center">
                      <a href={facs.profile} target="_blank" rel="noopener noreferrer" className="">
                        <ImProfile size={40} color="white" />
                      </a>
                    </div>
                  </button>
                </div>
              </ReactCardFlip>
              <h1 className="pt-3 text-xl text-white">{facs.position} </h1>
              <h1 className=" text-2xl text-white">{facs.name} </h1>
            </div>
          ))}
        </div>
      </div>
      <div className="py-10"></div>
      <div className="z-30 grid grid-cols-1 grid-rows-1 gap-28 md:grid-cols-2 lg:grid-cols-3">
        {profiles.map((profile, index) => (
          <div>
            <ReactCardFlip key={index} isFlipped={cardState[index]} flipDirection="vertical">
              <div className="card-front relative flex h-72 w-72 items-center justify-center rounded-full bg-gray-100 shadow-md">
                <button onClick={() => handleClick(index)} className="h-full w-full">
                  <img src={profile.image} alt={profile.name} className="h-full w-full rounded-full object-cover" />
                </button>
              </div>

              <div className="card-back glass-effect-circle relative flex h-72 w-72 flex-col items-center justify-center rounded-full p-6 shadow-md">
                <button onClick={() => handleClick(index)} className="h-full w-full">
                  <div className="mx-20 mt-4 flex justify-center">
                    <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="mr-4">
                      <FaLinkedin size={32} color="white" />
                    </a>
                    <a href={profile.instagram} target="_blank" rel="noopener noreferrer" className="">
                      <FaInstagram size={32} color="white" />
                    </a>
                  </div>
                </button>
              </div>
            </ReactCardFlip>
            <h1 className="pt-3 text-xl text-white">{profile.position} </h1>
            <h1 className=" text-2xl text-white">{profile.name} </h1>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
